/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportGraaspEuIlsDto } from '../../models/import-graasp-eu-ils-dto';
import { ImportGraaspEuIlsResult } from '../../models/import-graasp-eu-ils-result';

export interface GraaspEuIlsImportControllerImportGraaspEuIlsDto$Params {
  folderId: string;
      body: ImportGraaspEuIlsDto
}

export function graaspEuIlsImportControllerImportGraaspEuIlsDto(http: HttpClient, rootUrl: string, params: GraaspEuIlsImportControllerImportGraaspEuIlsDto$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportGraaspEuIlsResult>> {
  const rb = new RequestBuilder(rootUrl, graaspEuIlsImportControllerImportGraaspEuIlsDto.PATH, 'post');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportGraaspEuIlsResult>;
    })
  );
}

graaspEuIlsImportControllerImportGraaspEuIlsDto.PATH = '/graasp-eu-ils-import/dto/{folderId}';
